'use es6';

import { RECEIVE_EMAILS } from 'email-management-lib/refactor/actions/actionTypes';
const initialState = 0;
export default function total(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_EMAILS:
      return action.error === true ? initialState : action.payload.total;
    default:
      return state;
  }
}